<template>
  <v-app-bar app color="on-primary" density="compact">
    <v-app-bar-title>
      <div class="header">
        <div class="header-logo">
          <img
            src="/logo.png"
            alt="Live Nation GmbH - Berlin (Chausseestraße)"
            @click="backToSystem"
            :class="hasBacklink ? 'cursor-pointer' : ''"
          />
        </div>
      </div>
    </v-app-bar-title>
  </v-app-bar>
</template>

<script lang="ts" setup>
import { useRoute }       from "vue-router"
import { onMounted, ref } from "vue"

const route = useRoute()
const id = ref()

onMounted(async () => {
  if (route && route.name === "venue-specs") {
    id.value = parseInt(route.params.id.toString())
  }
  if (route && route.name === "requirements") {
    id.value = parseInt(route.params.id.toString())
  }
})

const backToSystem = () => {
  if (!hasBacklink) {
    // no redirect via logo here
    return
  }

  // following are special cases with specific redirects on logo click
  if (route && route.name === "incoming-invoice") {
    window.location.href = import.meta.env.VITE_CONCERTON_URL + "/incoming-invoice/index"
  } else if (route && route.name === "venue-specs") {
    window.location.href = import.meta.env.VITE_CONCERTON_URL + "/company/details?id=" + id.value + "&tab=venue-specs"
  } else if (route && route.name === "requirements") {
    window.location.href = import.meta.env.VITE_CONCERTON_URL + "/tour/details?id=" + id.value + "&tab=requirements"
  } else {
    // the rest links back to main index page
    window.location.href = import.meta.env.VITE_CONCERTON_URL
  }
}

const hasBacklink = () => {
  if (route && route.name === "tour-cash-register") {
    return false
  }

  // add other exceptions here as well
  // these have no backlinks via logo

  return true
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.v-toolbar__content > .v-toolbar-title {
  margin-inline-start: 0;
}

.header {
  height: 50px;
  padding-top: 5px;
  background-color: #1E262B;
  text-align: center;
}

.header-logo img {
  height: 40px;
}

.v-btn.v-theme--myCustomLightTheme.v-btn--density-default.v-btn--size-default.v-btn--variant-text {
  color: white;
}
</style>
